import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-close\"><path d=\"m24.031 9.03-6.97 6.971 6.968 6.969-1.06 1.06L16 17.061l-6.969 6.97-1.06-1.061L14.94 16 7.969 9.03l1.06-1.061L16 14.94l6.97-6.97 1.061 1.06Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol